export default class Boundable {
  getBounds() {}
}
export default class Boundable {
  getBounds() {}
}
